module.exports = __webpack_public_path__ + "media/images/hero_images/index-400-1afe47a04be73d9f29931e8998ceed10.jpg";